interface ApiPathType {
  /**Auth Management */
  signIn: string;
  signUp: string;
  forgotPassword: string;
  resetPassword: string;
  checkTokenExpiry: string;
  adminchangepassword: string;
  resendEmployeeInvite: string;

  /**Category Management */
  categoryAdd: string;
  categoryList: string;
  updateCategory: string;
  deleteCategory: string;
  categorySearch: string;

  /**Supplier Category Management */
  supplierCategoryAdd: string;
  updateSupplierCategory: string;
  supplierCategoryList: string;
  deleteSupplierCategory: string;

  /**Role Management */
  getRoleList: string;
  getPermissionById: string;
  createRole: string;
  updateRole: string;

  refreshToken: string;

  /**Employee Management */
  getAllEmployees: string;
  getEmployee: string;
  getEmployeeByRoleId: string;
  createEmployee: string;
  updateEmployee: string;
  employeecheckmobile: string;

  /**Product Management */
  getProductsDetails: string;
  getProductImages: string;
  getAllProducts: string;
  createProducts: string;
  updateProducts: string;
  editProduct: string;
  deleteProducts: string;
  searchProducts: string;
  productSearch: string;
  productWithSupplierMapUpdate: string;
  getSupplierMappedWithoutCustom: string;
  productfilehistory: string;
  productfilehistorylist: string;
  productRating: string;
  configureAWSKeys: string;
  getAWSInfo: string;
  checkProductFieldIsDuplicateOrNot: string;
  checkCountryMapping: string;

  uploadSingleFile: string;
  uploadMultipleFile: string;
  deleteSingleFile: string;
  getAllS3ImageFiles: string;

  /**Customer Management */
  customersList: string;
  customerById: string;

  /**Coupon Management */
  getCouponList: string;
  createCoupon: string;
  updateCoupon: string;
  deleteCoupon: string;

  /**Taxation Management */
  getTaxList: string;
  createTax: string;
  getTaxDetails: string;
  updateTax: string;
  deleteTax: string;
  getAllCountries: string;

  /**Customer Management */
  allCustomers: string;
  customers: string;
  updateCustomer: string;
  getCustomerWishlist: string;
  adminCustomerOrders: string;
  updateCustomerStatus: string;
  getOrderDetailByCustomerId: string;
  customersExport: string;
  getRefundDetailsByCustomerId: string;

  /**FAQ Management */
  faqList: string;
  faqUpdate: string;
  faqAdd: string;
  faqDelete: string;

  faqProductList: string;
  faqProductUpdate: string;
  faqProductAdd: string;
  faqProductDelete: string;
  productSheetUpload: string;
  allFileProcessResult: string;

  /**Supplier Management */
  createSupplier: string;
  updateSupplier: string;
  deleteSupplier: string;
  getSupplierList: string;
  supplierSyncRuns: string;
  supplierValidationLogs: string;
  supplierSyncSummary: string;
  getAllSupplierList: string;
  getsupplierapiinfo: string;
  supplierSearch: string;
  getSupplierDetails: string;
  deleteSupplierUnlink: string;
  updateSupplierApiKey: string;

  /**Membership Management */
  getMemberships: string;
  createMembership: string;
  updateMembership: string;
  deleteMembership: string;

  /**Terms & Conditions Management */
  getTerms: string;
  updateTerms: string;

  getPrivacyPolicy: string;
  updatePrivacyPolicy: string;

  /**Banner Management */
  getBanners: string;
  addBanner: string;
  deleteBanner: string;
  updateBanner: string;

  /** Dynamic Footer Links Management */
  addDynamicFooterLinks: string;

  /**Country Management */
  getCountry: string;
  getAllCountry: string;
  updateCountry: string;
  countryDialingInfoApi: string;
  countrySearch: string;

  /**Customer Home Layout */
  customerHomeLayoutListById: string;
  customerHomeLayoutSave: string;
  customerHomeLayoutUpdate: string;
  customerHomeLayoutList: string;

  /**Help Service Management */
  helpService: string;
  helpServiceById: string;
  helpServiceSave: string;
  helpServiceUpdate: string;
  helpServiceDelete: string;
  getNotification: string;
  addNotification: string;
  updateNotification: string;
  logoutUser: string;

  customerhelp: string;
  updateticketbyid: string;
  getpaymentgateway: string;
  paymentgatewayAdd: string;
  updatepaymentgateway: string;

  /**@Supplier And Product Mapping*/
  getSupplierAndProductMapping: string;
  createOrUpdateProductSupplierDenominationId: string;
  deleteSupplierAndProductMapping: string;
  deleteProductAndSupplierMapIndividually: string;
  getDiscountsFileList: string;

  /**Inventory Management */
  validateInventoryFile: string;
  uploadInventoryFile: string;
  tempUploadInventoryFile: string;
  inventoryList: string;
  inventorylistinmeta: string;
  inventoryFileHistoryList: string;
  inventoryfileblocked: string;
  inventoryfileemprecords: string;
  inventoryfileblockedhistorylist: string;
  inventoryFirstBatchPins: string;

  /**Order Management */
  getOrdersList: string;
  getOrderDetails: string;
  ordersExport: string;
  getCustomerOrderPin: string;
  invoiceDownload: string;
  creditMemoDownload: string;
  refundInvoiceDownload: string;
  orderRefundInvoices: string;
  /**Refund Management */
  getRefundsList: string;
  getRefundDetails: string;
  refundsExport: string;
  createRefund: string;
  /**Supplier Topup Settings */
  supplierTopupSettingsGet: string;
  supplierTopupSettingsCreate: string;
  supplierTopupSettingsUpdate: string;

  /**Supplier Provider Product Search */
  supplierProviderProductSearch: string;
  allSupplierProducts: string;
  allSupplierProvidersList: string;
  validateSubSupplier: string;
  supplierProductPriceList: string;
  dynamicLinkProductWithSupplierProduct: string;
  dynamicProductWithSupplierActiveList: string;

  /**Reports */
  getSalesReport: string;
  getApiTransactionFilterOptions: string;
  supplierReconciliationExport: string;
  reportFilterOptions: string;
  paymentList: string;
  reportLogs: string;
  getProductReport: string;
  getPinLogs: string;
  processcreditmemo: string;
  getRabbitMQLogs: string;

  purchaseExport: string;
  paymentsExport: string;

  /**Supplier Provider Product Management */
  createSupplierProviderManualy: string;
  updateSupplierProviderManualy: string;
  saveSupplierProviderDenominationsManually: string;
  deleteManualSupplierProvider: string;
  inventoryTempRecordsList: string;

  uploadmultiple: string;
  uploadImportImages: string;

  createsupplieraccount: string;
  updateSupplierAccount: string;
  getSubSuppliersOfAll: string;
  getSupplierCredentials: string;
  getSubSuppliersBySupplierId: string;

  getLatestProductsFromCron: string;

  /**Service Fee */
  createServiceFee: string;
  getServiceFeeById: string;
  updateServiceFee: string;
  deleteServiceFee: string;
  getServiceFeeList: string;
  getModuleList: string;

  /**Wallet */
  createWallet: string;
  getWalletById: string;
  updateWallet: string;
  deleteWallet: string;
  getWalletList: string;
  getByUserId: string;

  // BankTransfers
  getBankTransfersList: string;
  getPaymentFailures: string;
  blockOrderPins: string;
  resolvePaymentFailure: string;
  retryCapture: string;
  approveBankTransfer: string;
  rejectbanktransfer: string;
  getBankTransfersById: string;
  deleteBankTransfers: string;

  // Prefixes
  getPrefixes: string;
  addOrUpdatePrefix: string;

  // Bank Details
  getActiveBankDetails: string;
  saveBankDetails: string;
  bankDetailsLogs: string;

  // Dashboard
  dashboardSummary: string;
  dashboardRevenueTrend: string;
  dashboardOrdersTrend: string;
  dashboardPaymentAnalytics: string;
  dashboardTopProducts: string;
  dashboardCustomerAnalytics: string;
  dashboardRefundAnalytics: string;
  dashboardInventoryStatus: string;
  dashboardRecentOrders: string;
  dashboardDeliveryStats: string;
}

const ApiPath: ApiPathType = {
  /**Auth Management */
  signIn: `/employeelogin` as const,
  signUp: `/users/add` as const,
  forgotPassword: `/employeefrgtpassword` as const,
  resetPassword: `/employee-reset-password` as const,
  checkTokenExpiry: `/employee_checkToken` as const,
  adminchangepassword: `/admin/employee-change-password` as const,
  resendEmployeeInvite: `/admin/employee-resend-invite` as const,

  /**Category Management */
  categoryAdd: `/createcategory` as const,
  categoryList: `/allcategory` as const,
  updateCategory: `/updatecategory${""}` as const,
  deleteCategory: `/deletecategory${""}` as const,
  categorySearch: `/categorysearch${""}` as const,

  /**Supplier Category Management */
  supplierCategoryAdd: `/supplier-createcategory` as const,
  supplierCategoryList: `/supplier-allcategory` as const,
  updateSupplierCategory: `/supplier-updatecategory${""}` as const,
  deleteSupplierCategory: `/supplier-deletecategory${""}` as const,
  getsupplierapiinfo: `/getsupplierapiinfo` as const,
  updateSupplierApiKey: `/updatesupplierapiinfo${""}` as const,

  /**Role Management */
  getRoleList: `/roles` as const,
  getPermissionById: `/roles${""}` as const,
  createRole: `/createrole` as const,
  updateRole: `/updaterole` as const,
  refreshToken: `/refresh-token` as const,
  logoutUser: `/employee/logout${""}` as const,

  /**Employee Management */
  getAllEmployees: `/allemployee` as const,
  getEmployee: `/employee` as const,
  getEmployeeByRoleId: `/rolewiseemp${""}` as const,
  createEmployee: `/createemployee` as const,
  updateEmployee: `/updateemployee${""}` as const,
  employeecheckmobile: `/employeecheckmobile` as const,

  /**Products Management */
  getProductsDetails: `/getproduct${""}` as const,
  getAllProducts: `/allproduct` as const,
  createProducts: `/createproduct` as const,
  updateProducts: `/updateproduct${""}` as const,
  editProduct: `/editProduct${""}` as const,
  deleteProducts: `/deleteproduct${""}` as const,
  searchProducts: `/product/search${""}` as const,
  productSearch: `/products-search` as const,
  productWithSupplierMapUpdate: `/updateproductsupplier${""}` as const,
  getSupplierMappedWithoutCustom: `/product${""}` as const,
  productfilehistory: `/productfilehistory` as const,
  productfilehistorylist: `/productfilehistorylist` as const,
  getProductImages: `/allimages` as const,
  productRating: `/ratings` as const,
  configureAWSKeys: `/aws/s3/create` as const,
  getAWSInfo: "/aws/s3/getById" as const,
  checkProductFieldIsDuplicateOrNot: `/validateproductfield` as const,
  checkCountryMapping: `/product/check-country-mapping` as const,

  uploadSingleFile: `/aws/s3/upload/single` as const,
  uploadMultipleFile: `/aws/s3/upload/multiple` as const,
  deleteSingleFile: `/aws/s3/uploads` as const,
  getAllS3ImageFiles: `/aws/s3/uploads` as const,

  /**Customers Management */
  allCustomers: `/allcustomers` as const,
  customersList: `/customers` as const,
  updateCustomer: `/updatecustomer${""}` as const,
  getCustomerWishlist: `/getWishListByCustomerId` as const,
  adminCustomerOrders: `/admincustomerorders` as const,
  updateCustomerStatus: `/customerstatus${""}` as const,
  getOrderDetailByCustomerId: `/orders${""}` as const,
  getRefundDetailsByCustomerId: `/refunds${""}` as const,

  customersExport: `/customers/export` as const,

  /**Coupon Management */
  getCouponList: `/coupon` as const,
  createCoupon: `/createCoupon` as const,
  updateCoupon: `/updateCoupon${""}` as const,
  deleteCoupon: `/deleteCoupon${""}` as const,

  /**Taxation Management */
  getTaxList: `/tax/profile/getAll` as const,
  createTax: `/tax/profile/create` as const,
  getTaxDetails: `/tax/profile/getById${""}` as const,
  updateTax: `/tax/profile/update${""}` as const,
  deleteTax: `/tax/profile/delete${""}` as const,
  getAllCountries: `/tax/countries/getall` as const,

  customers: `/customers` as const,
  customerById: `/customer${""}` as const,

  /**FAQ Management */
  faqList: `/faq` as const,
  faqUpdate: `/updatefaq${""}` as const,
  faqAdd: `/createfaq${""}` as const,
  faqDelete: `/faq${""}` as const,

  /**FAQ Product Management */
  faqProductList: `/productfaq` as const,
  faqProductUpdate: `/updateproductfaq${""}` as const,
  faqProductAdd: `/createproductfaq` as const,
  faqProductDelete: `/deleteproductfaq${""}` as const,
  productSheetUpload: `/productsheetupload${""}` as const,
  allFileProcessResult: `/inventoryfilehistory` as const,

  /**Supplier Management */
  createSupplier: `/createsupplier` as const,
  updateSupplier: `/updatesupplier${""}` as const,
  deleteSupplier: `/deletesupplier${""}` as const,
  // supplierSearch: `/supplier-search?name=${""}` as const,
  supplierSearch: `/supplierAccount-search` as const,
  getSupplierList: `/supplier` as const,
  supplierSyncRuns: `/supplier-sync-runs` as const,
  supplierValidationLogs: `/supplier-validation-logs` as const,
  supplierSyncSummary: `/supplier-sync-runs/summary` as const,
  getAllSupplierList: `/getall` as const,
  // getAllSupplierList: `/allsupplier` as const,
  // getSupplierDetails: `/supplier${''}` as const,
  validateSubSupplier: `/validate-supplier` as const,
  getSupplierDetails: `/supplierAccount${""}` as const,
  deleteSupplierUnlink: `/deletedynamicsupplierprovider${""}` as const,
  allSupplierProvidersList: `/allsupplierproviders${""}` as const,

  /**Membership Management */
  getMemberships: `/membership` as const,
  createMembership: `/createMembership` as const,
  updateMembership: `/updateMembership${""}` as const,
  deleteMembership: `/deleteMembership${""}` as const,

  /**Term & Condition */
  getTerms: `/termscnd` as const,
  updateTerms: `/updatetermscnd${""}` as const,

  /**Privacy Policy */
  getPrivacyPolicy: `/privacyplcy` as const,
  updatePrivacyPolicy: `/updateprivacyplcy${""}` as const,

  /**Banner for Web/Mobile APP */
  getBanners: `/banner` as const,
  addBanner: `/createbanner` as const,
  deleteBanner: `/deletebanner${""}` as const,
  updateBanner: `/updatebanner${""}` as const,

  /** Dynamic Footer Links Management */
  addDynamicFooterLinks: `/footer` as const,

  /**Get Country for Web/Mobile APP */
  getCountry: `/country` as const,
  getAllCountry: `/allcountry` as const,
  updateCountry: `/updatecountry${""}` as const,
  countryDialingInfoApi: `/country-dialing-info` as const,
  countrySearch: `/countrysearch` as const,

  /**CUSTOMER Home for Web/Mobile APP */
  customerHomeLayoutList: `/allhomedata` as const,
  customerHomeLayoutListById: `/gethome${""}` as const,
  customerHomeLayoutSave: `/createhome` as const,
  customerHomeLayoutUpdate: `/updatehome${""}` as const,

  /**Service Fee */
  createServiceFee: `/servicefee` as const,
  getServiceFeeById: `/servicefee${""}` as const,
  updateServiceFee: `/servicefee${""}` as const,
  deleteServiceFee: `/servicefee${""}` as const,
  getServiceFeeList: `/servicefee/getall` as const,
  getModuleList: `/servicefeetable` as const,

  /**Wallet */
  createWallet: `/wallet` as const,
  getWalletById: `/wallet/transactions${""}` as const,
  updateWallet: `/wallet/transactions${""}` as const,
  deleteWallet: `/wallet/transactions${""}` as const,
  getByUserId: `/wallet/getByUserId/${""}` as const,
  getWalletList: `/wallet/transactions` as const,

  // BankTransfers
  getBankTransfersList: `/banktransferorders` as const,
  getPaymentFailures: `/paymentfailureorders` as const,
  blockOrderPins: `/paymentfailure/block-pins` as const,
  resolvePaymentFailure: `/paymentfailure/resolve` as const,
  retryCapture: `/adyen/capture` as const,
  approveBankTransfer: `/approvebanktransferorder` as const,
  rejectbanktransfer: `/rejectbanktransferorders` as const,
  getBankTransfersById: `/banktransfers${""}` as const,
  deleteBankTransfers: `/banktransfers${""}` as const,

  // getModuleFields: `/servicefeetable` as const,

  /**Get Country for Web/Mobile APP */

  /**Help Service */
  helpService: `/helpservice` as const,
  helpServiceById: `/helpservice${""}` as const,
  helpServiceSave: `/createhelpservice` as const,
  helpServiceUpdate: `/updatehelpservice${""}` as const,
  helpServiceDelete: `/deletehelpservice${""}` as const,

  getNotification: `/getNotification` as const,
  addNotification: `/addNotification` as const,
  updateNotification: `/updateNotification${""}` as const,

  customerhelp: `/ticketslist` as const,
  updateticketbyid: `/updateticketbyid${""}` as const,

  getpaymentgateway: `/getpaymentgateway` as const,
  paymentgatewayAdd: `/addpaymentgateway` as const,
  updatepaymentgateway: `/addpaymentgateway${""}` as const,

  getSupplierAndProductMapping: `/productandsuppliermap` as const,
  createOrUpdateProductSupplierDenominationId:
    `/createorupdateproductsupplierdenomination` as const,
  deleteSupplierAndProductMapping: `/deletedataproductandsuppliermap` as const,
  deleteProductAndSupplierMapIndividually:
    `/deleteproductandsuppliermap` as const,
  getDiscountsFileList: `/getdiscountsfilelist` as const,

  /**Inventory Management */
  validateInventoryFile: `/inventoryfilevalidate` as const,
  uploadInventoryFile: `/inventoryfileupload` as const,
  tempUploadInventoryFile: `/inventoryfiletempupload` as const,
  inventoryList: `/inventorylist` as const,
  inventorylistinmeta: `/inventorylistinmeta` as const,

  inventoryFileHistoryList: `/inventoryfilekeybyhistory` as const,
  inventoryfileblocked: `/inventoryfilepinsmanage` as const,
  inventoryfileemprecords: `/inventoryfileemprecords` as const,
  inventoryfileblockedhistorylist: `/inventoryfileblockedhistorylist` as const,

  inventoryFirstBatchPins: `/import/firstbatchpin` as const,

  /**Order List for Admin Panel */
  getOrdersList: `/adminorderslist` as const,
  getOrderDetails: `/adminorderslist-details${""}` as const,
  ordersExport: `/adminorders/export` as const,
  getCustomerOrderPin: `/getcustomerpin${""}` as const,
  invoiceDownload: `/invoice-download` as const,
  creditMemoDownload: `/creditmemo-download` as const,
  refundInvoiceDownload: `/refundinvoice-download` as const,
  orderRefundInvoices: `/order-refundinvoices` as const,
  /**Refund List for Admin Panel */
  /** Refund List for Admin Panel */
  getRefundsList: `/adminrefundslist` as const,
  getRefundDetails: `/adminrefundslist-details${""}` as const,
  refundsExport: `/adminrefunds/export` as const,

  createRefund: `/adminrefunds/create` as const,

  /**Supplier Settings */
  supplierTopupSettingsGet: `/allsuppliersetting` as const,
  supplierTopupSettingsCreate: `/createsuppliersetting` as const,
  supplierTopupSettingsUpdate: `/updatesuppliersetting${""}` as const,

  /**PRODUCT_SEARCH_FORVALIDATION */
  supplierProviderProductSearch: `/supplierprovider-productsearch` as const,
  allSupplierProducts: `/allsupplierproducts` as const,
  supplierProductPriceList: `/providerwiseallsupplierdenomination` as const,
  dynamicLinkProductWithSupplierProduct: `/supplierproductlink` as const,
  dynamicProductWithSupplierActiveList:
    `/productwisesupplieractivelist` as const,

  /**Reports */
  getSalesReport: `/allpurchase-orders` as const,
  getApiTransactionFilterOptions: `/api-transaction-filter-options` as const,
  // Supplier reconciliation: built and streamed on the request, unlike the
  // async export paths which write a job row nobody ever processes.
  supplierReconciliationExport: `/reports/supplier-reconciliation` as const,
  reportFilterOptions: `/reports/filter-options` as const,
  paymentList: `/allpaymeents` as const,
  reportLogs: `/reportexportlogs` as const,
  getProductReport: `/allorderitems` as const,
  getPinLogs: `/pinlogs` as const,
  processcreditmemo: `/processcreditmemo` as const,
  getRabbitMQLogs: `/admin/api-logs/order/` as const,

  purchaseExport: `/purchase-orders/export` as const,
  paymentsExport: `/payments/export` as const,

  /**@Supplier Provider Product add and Update */
  createSupplierProviderManualy: `/createsupplierprovider` as const,
  updateSupplierProviderManualy: `/updatesupplierprovider` as const,
  saveSupplierProviderDenominationsManually: `/upsertsupplierproducts` as const,
  deleteManualSupplierProvider: `/supplierprovider/manual` as const,
  inventoryTempRecordsList: `/inventorytemprecords` as const,

  uploadmultiple: `/upload-multiple` as const,
  uploadImportImages: `/product-import/images` as const,
  createsupplieraccount: `/createsupplieraccount` as const,
  updateSupplierAccount: `/updateSupplierAccount${""}` as const,
  getSubSuppliersOfAll: `/getall` as const,
  getSupplierCredentials: `/suppliercredentials${""}` as const,
  getSubSuppliersBySupplierId: `/getallsubacc${""}` as const,
  getLatestProductsFromCron: `/runsyncmanual` as const,

  getPrefixes: `/getallnumberseries` as const,
  addOrUpdatePrefix: `/createnumberseries` as const,

  // Bank Details
  getActiveBankDetails: `/bankdetails` as const,
  saveBankDetails: `/savebankdetails` as const,
  bankDetailsLogs: `/bankdetails/logs` as const,

  // Dashboard
  dashboardSummary: `/admin/dashboard/summary` as const,
  dashboardRevenueTrend: `/admin/dashboard/revenue-trend` as const,
  dashboardOrdersTrend: `/admin/dashboard/orders-trend` as const,
  dashboardPaymentAnalytics: `/admin/dashboard/payment-analytics` as const,
  dashboardTopProducts: `/admin/dashboard/top-products` as const,
  dashboardCustomerAnalytics: `/admin/dashboard/customer-analytics` as const,
  dashboardRefundAnalytics: `/admin/dashboard/refund-analytics` as const,
  dashboardInventoryStatus: `/admin/dashboard/inventory-status` as const,
  dashboardRecentOrders: `/admin/dashboard/recent-orders` as const,
  dashboardDeliveryStats: `/admin/dashboard/delivery-stats` as const,
};

export default ApiPath;
